// extracted by mini-css-extract-plugin
export default {"operationArea":"List_operationArea__tkPbx","applyLog":"List_applyLog__oKWeZ","danger":"List_danger__UteqB"};